<template>
	<!--	<div>-->
	<!--		<header>-->
	<!--			<h1>Estate Agent Comparison</h1>-->
	<!--		</header>-->
	<!--		<div>-->
	<!--			<section class="section">-->
	<!--				<form @submit.prevent="submit">-->
	<!--					<label><span>Postcode </span>-->
	<!--						<div v-if="form.errors.get('postcode')" class="error-block">-->
	<!--							<p v-html="form.errors.get('postcode')"></p>-->
	<!--						</div>-->
	<!--						<input v-model="form.data.postcode" type="text">-->
	<!--					</label>-->
	<!--					<label><span>Refine By Bedrooms </span>-->
	<!--						<select v-model="bedrooms">-->
	<!--							<option value="">All</option>-->
	<!--							<option value="1">1</option>-->
	<!--							<option value="2">2</option>-->
	<!--							<option value="3">3</option>-->
	<!--							<option value="4">4</option>-->
	<!--							<option value="5">5 or more</option>-->
	<!--						</select>-->
	<!--					</label>-->
	<!--					<label><span>Sort By </span>-->
	<!--						<select v-model="sort">-->
	<!--							<option value="askingPrice">Asking Price</option>-->
	<!--							<option value="propertiesListed">Properties Listed</option>-->
	<!--							<option value="propertiesSold">Properties Sold</option>-->
	<!--							<option value="saleTime">Sale Time</option>-->
	<!--						</select>-->
	<!--					</label>-->
	<!--					<ul class="actions">-->
	<!--						<li>-->
	<!--							<process-button-->
	<!--								:processing="form.processing" class="button button&#45;&#45;primary"-->
	<!--								text="Get Comparison"></process-button>-->
	<!--						</li>-->
	<!--					</ul>-->
	<!--				</form>-->
	<!--			</section>-->
	<!--			<template v-if="comparison">-->
	<!--				<section v-if="stats" class="sections sections&#45;&#45;flexed">-->
	<!--					<section class="metrics__metric&#45;&#45;number section">-->
	<!--						<p class="metrics__metric__stats">-->
	<!--							<span class="metrics__metric__stats__title">Properties Listed </span>-->
	<!--							<span-->
	<!--								class="metrics__metric__stats__value &#45;&#45;large" v-html="stats.numberOfNewListings"></span>-->
	<!--							<span>in the last 12 months</span>-->
	<!--						</p>-->
	<!--					</section>-->
	<!--					<section class="metrics__metric&#45;&#45;number section">-->
	<!--						<p class="metrics__metric__stats">-->
	<!--							<span class="metrics__metric__stats__title">Average Sale Time </span>-->
	<!--							<span>-->
	<!--									<span-->
	<!--										class="metrics__metric__stats__value &#45;&#45;large"-->
	<!--										v-html="stats.averageSaleDuration.inWeeksAndDays.weeks"></span> weeks <span-->
	<!--								class="metrics__metric__stats__value &#45;&#45;large"-->
	<!--								v-html="stats.averageSaleDuration.inWeeksAndDays.days"></span> days-->
	<!--								</span>-->
	<!--						</p>-->
	<!--					</section>-->
	<!--					<section class="metrics__metric&#45;&#45;number section">-->
	<!--						<p class="metrics__metric__stats">-->
	<!--							<span class="metrics__metric__stats__title">Properties Sold </span>-->
	<!--							<span class="metrics__metric__stats__value &#45;&#45;large"><span-->
	<!--								v-html="stats.soldRatio.withSymbol"></span></span>-->
	<!--						</p>-->
	<!--					</section>-->
	<!--					<section class="metrics__metric&#45;&#45;number section">-->
	<!--						<p class="metrics__metric__stats">-->
	<!--							<span class="metrics__metric__stats__title">Average Asking Price Achieved </span>-->
	<!--							<span class="metrics__metric__stats__value &#45;&#45;large"><span-->
	<!--								v-html="stats.averageAskingPrice.withSymbol"></span></span>-->
	<!--						</p>-->
	<!--					</section>-->
	<!--				</section>-->
	<!--				<section class="section section&#45;&#45;expanded">-->
	<!--					<table class="comparison&#45;&#45;estate-agent">-->
	<!--						<thead>-->
	<!--							<tr>-->
	<!--								<th align="left">Agents</th>-->
	<!--								<th>Properties Listed</th>-->
	<!--								<th>Properties Sold</th>-->
	<!--								<th>Asking Price</th>-->
	<!--								<th>Sale Time</th>-->
	<!--							</tr>-->
	<!--						</thead>-->
	<!--						<tr-->
	<!--							v-for="(agent, agentIndex) in agents" :class="agentClass(agent)"-->
	<!--							class="estate-agent-comparison__agent">-->
	<!--							<td>-->
	<!--								{{ agent.name }}-->
	<!--								<template v-if="performanceBadges(agent).length">-->
	<!--									<ul>-->
	<!--										<li v-for="(stat, statIndex) in performanceBadges(agent)" :key="statIndex"><span-->
	<!--											class="badge&#45;&#45;best-performer" v-html="performance(stat)"/>-->
	<!--										</li>-->
	<!--									</ul>-->
	<!--								</template>-->
	<!--							</td>-->
	<!--							<td align="center"><span-->
	<!--								class="metrics__metric__stats__value"-->
	<!--								v-html="agent.numberOfNewListings"/>-->
	<!--							</td>-->
	<!--							<td align="center" class="metrics__metric__stats__value"><span-->
	<!--								v-html="agent.numberOfListingsSold"/></td>-->
	<!--							<td align="center" class="metrics__metric__stats__value"><span-->
	<!--								v-html="agent.averageAskingPrice.withSymbol"></span></td>-->
	<!--							<td align="center"><span-->
	<!--								class="metrics__metric__stats__value"-->
	<!--								v-html="agent.averageSaleDuration.inWeeks"/>-->
	<!--							</td>-->
	<!--						</tr>-->
	<!--					</table>-->
	<!--				</section>-->
	<!--			</template>-->
	<!--		</div>-->
	<!--	</div>-->
	<div>
		<header class="flex-apart">
			<h1 class="alpha heavy">Estate Agent Comparison</h1>
		</header>
		<div class="v-table">
			<form class="section" @submit.prevent="submit">
				<label><span>Postcode </span>
					<div v-if="form.errors.get('postcode')" class="error-block">
						<p v-html="form.errors.get('postcode')"></p>
					</div>
					<input v-model="form.data.postcode" type="text">
				</label>
				<label><span>Refine By Bedrooms </span>
					<select v-model="bedrooms">
						<option value="">All</option>
						<option value="1">1</option>
						<option value="2">2</option>
						<option value="3">3</option>
						<option value="4">4</option>
						<option value="5">5 or more</option>
					</select>
				</label>
				<label><span>Sort By </span>
					<select v-model="sort">
						<option value="askingPrice">Asking Price</option>
						<option value="propertiesListed">Properties Listed</option>
						<option value="propertiesSold">Properties Sold</option>
						<option value="saleTime">Sale Time</option>
					</select>
				</label>
				<ul class="actions">
					<li>
						<process-button
							:processing="form.processing" class="button button--primary"
							text="Get Comparison"></process-button>
					</li>
				</ul>
			</form>
			<table v-if="comparison" class="comparison--estate-agent">
				<thead>
					<tr>
						<th align="left">Agents</th>
						<th>Properties Listed</th>
						<th>Properties Sold</th>
						<th>Asking Price</th>
						<th>Sale Time</th>
					</tr>
				</thead>
				<tr
					v-for="(agent, agentIndex) in agents" :class="agentClass(agent)"
					class="estate-agent-comparison__agent">
					<td>
						{{ agent.name }}
						<template v-if="performanceBadges(agent).length">
							<ul>
								<li v-for="(stat, statIndex) in performanceBadges(agent)" :key="statIndex"><span
									class="badge--best-performer" v-html="performance(stat)"/>
								</li>
							</ul>
						</template>
					</td>
					<td align="center"><span
						class="metrics__metric__stats__value"
						v-html="agent.numberOfNewListings"/>
					</td>
					<td align="center" class="metrics__metric__stats__value"><span
						v-html="agent.numberOfListingsSold"/></td>
					<td align="center" class="metrics__metric__stats__value"><span
						v-html="agent.averageAskingPrice.withSymbol"></span></td>
					<td align="center"><span
						class="metrics__metric__stats__value"
						v-html="agent.averageSaleDuration.inWeeks"/>
					</td>
				</tr>
			</table>
			<!--			<div  class="sections">-->
			<!--				<section v-if="stats" class="sections sections&#45;&#45;flexed">-->
			<!--					<section class="metrics__metric&#45;&#45;number section">-->
			<!--						<p class="metrics__metric__stats">-->
			<!--							<span class="metrics__metric__stats__title">Properties Listed </span>-->
			<!--							<span-->
			<!--								class="metrics__metric__stats__value &#45;&#45;large" v-html="stats.numberOfNewListings"></span>-->
			<!--							<span>in the last 12 months</span>-->
			<!--						</p>-->
			<!--					</section>-->
			<!--					<section class="metrics__metric&#45;&#45;number section">-->
			<!--						<p class="metrics__metric__stats">-->
			<!--							<span class="metrics__metric__stats__title">Average Sale Time </span>-->
			<!--							<span>-->
			<!--												<span-->
			<!--													class="metrics__metric__stats__value &#45;&#45;large"-->
			<!--													v-html="stats.averageSaleDuration.inWeeksAndDays.weeks"></span> weeks <span-->
			<!--								class="metrics__metric__stats__value &#45;&#45;large"-->
			<!--								v-html="stats.averageSaleDuration.inWeeksAndDays.days"></span> days-->
			<!--											</span>-->
			<!--						</p>-->
			<!--					</section>-->
			<!--					<section class="metrics__metric&#45;&#45;number section">-->
			<!--						<p class="metrics__metric__stats">-->
			<!--							<span class="metrics__metric__stats__title">Properties Sold </span>-->
			<!--							<span class="metrics__metric__stats__value &#45;&#45;large"><span-->
			<!--								v-html="stats.soldRatio.withSymbol"></span></span>-->
			<!--						</p>-->
			<!--					</section>-->
			<!--					<section class="metrics__metric&#45;&#45;number section">-->
			<!--						<p class="metrics__metric__stats">-->
			<!--							<span class="metrics__metric__stats__title">Average Asking Price Achieved </span>-->
			<!--							<span class="metrics__metric__stats__value &#45;&#45;large"><span-->
			<!--								v-html="stats.averageAskingPrice.withSymbol"></span></span>-->
			<!--						</p>-->
			<!--					</section>-->
			<!--				</section>-->
			<!--				<section class="section section&#45;&#45;full">-->
			<!--					-->
			<!--				</section>-->
			<!--			</div>-->
		</div>
	</div>
</template>
<script>

export default {
	data() {
		return {
			form: this.newForm({
				postcode: null,
			}),
			bedrooms: "",
			sort: "propertiesListed",
			comparison: null,
		};
	},

	computed: {
		stats() {
			if (!this.comparison) {
				return null;
			}

			return this.refine ? _.get(this.comparison.statsByBedrooms, this.refine) : this.comparison.stats;
		},
		agents() {
			let serviceProviders = _.filter(this.comparison.agents, function (serviceProvider) {
				return serviceProvider.branchId;
			});

			if (this.bedrooms) {
				serviceProviders = _.filter(serviceProviders, serviceProvider => {
					return _.has(serviceProvider.bedrooms, this.bedrooms);
				});
			}

			return _.orderBy(serviceProviders, serviceProvider => {
				return {
					propertiesListed: this.serviceProviderMetric(serviceProvider).numberOfNewListings,
					propertiesSold: this.serviceProviderMetric(serviceProvider).numberOfListingsSold,
					askingPrice: this.serviceProviderMetric(serviceProvider).averageAskingPrice.percent,
					saleTime: this.serviceProviderMetric(serviceProvider).averageSaleDuration.inDays,
				}[this.sort];
			}, "saleTime" === this.sort ? "asc" : "desc");
		},
		bestPerformers() {
			return this.bedrooms
				? _.get(this.comparison.meta.bestPerformersByBedrooms, this.bedrooms)
				: this.comparison.meta.bestPerformers;
		},
	},

	methods: {
		agentClass(agent) {
			return {
				preferred: agent.preferred,
			};
		},
		serviceProviderIsABestPerformer(serviceProvider, metric) {
			return !!_.find(this.bestPerformers[metric], function (_serviceProvider) {
				return _serviceProvider.branchId === serviceProvider.branchId;
			});
		},
		serviceProviderMetric(serviceProvider) {
			return this.bedrooms
				? _.get(serviceProvider.bedrooms, this.bedrooms)
				: serviceProvider;
		},
		performanceBadges(serviceProvider) {
			return _.keys(_.pickBy({
				propertiesListed: this.serviceProviderIsABestPerformer(serviceProvider, "byPropertiesListed"),
				propertiesSold: this.serviceProviderIsABestPerformer(serviceProvider, "byPropertiesSold"),
				askingPrice: this.serviceProviderIsABestPerformer(serviceProvider, "byPercentageOfAskingPriceAchieved"),
				saleTime: this.serviceProviderIsABestPerformer(serviceProvider, "bySaleDuration"),
			}, stat => stat));
		},
		performance(stat) {
			return {
				propertiesListed: "Most Properties Listed",
				propertiesSold: "Most Properties Sold",
				askingPrice: "Best For Asking Price",
				saleTime: "Fastest Seller",
			}[stat];
		},
		async submit() {
			this.form.post("tools/estate-agent-comparison").then(response => {
				this.comparison = response.data;
			});
		},
	},
};
</script>
